import React, {useState} from 'react';
import s from './MainLessons.module.css';
import greenArrow from '../../../assets/img/icons/Lessons/material-symbols_play-arrow green.svg';
import AskQuestionCheckBox from './AnswerQuestionCheckBox';
import {AnswerType} from '../../../types/TypesEducation';

type Props = {
	title: string;
	answers: AnswerType[];
	setFieldValue: any;
	index: number;
	questionId: number | null;
	values: any;
};
const TaskQuestionElement: React.FC<Props> = ({
	values,
	title,
	answers,
	setFieldValue,
	index,
	questionId,
}) => {
	const [openTask, setOpenTask] = useState(false);

	return (
		<div className="slider-marketing__item item-slider-marketing">
			<div
				role="button"
				tabIndex={0}
				onClick={() => setOpenTask(!openTask)}
				className={`${s.taskTitle} item-slider-marketing__number`}
			>
				<img
					style={{transform: openTask ? '' : 'rotate(180deg)'}}
					src={greenArrow}
					alt="greenArrow"
				/>
				<span>{title}</span>
			</div>
			<div className={`${s.taskQuestion} item-slider-marketing__text`}>
				{openTask && (
					<>
						{title}
						<div className={s.answerContainer}>
							{answers?.map((answer, answerIndex: number) => {
								/*const curIndex = values?.data[index]?.answer?.findIndex(
									(el: any) => el === answer?.id,
								);*/
								const check =
									values?.data[index]?.question_id === questionId &&
									values?.data[index]?.answer?.includes(answer.id ?? '') &&
									true;

								return (
									<div key={`answer2${answer.id}`}>
										<AskQuestionCheckBox
											labelTxt={answer.title}
											id={answer?.id?.toString() ?? ''}
											check={check}
											onChangeFn={() => {
												if (!check) {
													setFieldValue(
														`data[${index}]answer[${answerIndex}]`,
														answer?.id,
													);
													setFieldValue(
														`data[${index}]question_id`,
														questionId,
													);
												} else {
													const newValue = values?.data[index]?.answer?.filter(
														(el: any) => el !== answer?.id,
													);
													setFieldValue(`data[${index}]answer`, newValue);
												}
											}}
										/>
									</div>

									//<InfoCheckbox labelTxt={answer.title} id={answer.id} type={'radio'} name={'questions[]['+questionId+'][answer]'} />
								);
							})}
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default TaskQuestionElement;
